import React from "react";
import PropTypes from "prop-types";

import { Field, Control, Label, Input } from "rbx";

import { DateInput } from "../inputs";

const HolidayForm = ({ inputs, onChange }) => (
  <React.Fragment>
    <Field>
      <Control>
        <Label>Holiday Date</Label>
        <DateInput
          required
          name="HolidayDate"
          value={inputs.HolidayDate}
          onChange={onChange}
        />
      </Control>
    </Field>
    <Field>
      <Control>
        <Label>Holiday Description</Label>
        <Input
          required
          autoComplete="new"
          name="HolidayDescription"
          type="text"
          value={inputs.HolidayDescription}
          onChange={onChange}
        />
      </Control>
    </Field>
  </React.Fragment>
);

HolidayForm.propTypes = {
  inputs: PropTypes.object,
  onChange: PropTypes.func
};
export default HolidayForm;
